import { render, staticRenderFns } from "./TopBarOnlyLogo.vue?vue&type=template&id=2cb4f336&scoped=true"
import script from "./TopBarOnlyLogo.vue?vue&type=script&lang=js"
export * from "./TopBarOnlyLogo.vue?vue&type=script&lang=js"
import style0 from "./TopBarOnlyLogo.vue?vue&type=style&index=0&id=2cb4f336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4f336",
  null
  
)

export default component.exports